import { gql } from "@apollo/client"
import { DeletePaymentsGroupInput, DeletePaymentsGroupPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

export const DELETE_INVOICES_BATCH_MUTATION = gql`
  mutation DeletePaymentsGroup($paymentsGroupId: ID!) {
    deletePaymentsGroup(input: { paymentsGroupId: $paymentsGroupId }) {
      paymentsGroup {
        id
        state
      }
      errors
    }
  }
`

export const useDeleteInvoicesBatch = (
  options?: InjectedOptions<
    { deletePaymentsGroup: DeletePaymentsGroupPayload },
    DeletePaymentsGroupInput
  >,
) => useMutation(DELETE_INVOICES_BATCH_MUTATION, options)
